import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  RouterService,
  StateService,
  ToolService,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-machinery-overview',
  templateUrl: './machinery-overview.component.html',
  styleUrls: ['./machinery-overview.component.scss'],
  standalone: false,
})
export class MachineryOverviewComponent implements OnInit {
  constructor(
    public routerService: RouterService,
    public state: StateService,
    public modalCtrl: ModalController,
    public toolService: ToolService
  ) {}

  sub: Subscription;
  selectedTab: number = 0;

  ngOnInit() {}

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  segmentChanged(event: any) {
    this.selectedTab = event.detail.value;
  }
}
